export default [
  {
    header: 'sections.navigation',
    sections: [
      // {
      //   label: 'sections.home',
      //   route: '/home'
      // },
      {
        label: 'sections.campaignDesigner',
        route: '/campaigns',
        requiredScope: 'VIEW_CAMPAIGN'
      },
      // {
      //   label: 'sections.campaignMonitoring',
      //   route: '/monitoring'
      // },
      {
        label: 'sections.executionRules.label',
        sections: [
          {
            label: 'sections.executionRules.exclusionRules.label',
            route: '/executionrules/exclusionrules'
          },
          {
            label: 'sections.executionRules.sendingRules.label',
            route: '/executionrules/sendingrules'
          }
        ],
        requiredScope: ['VIEW_EXECUTION_RULE', 'AFTER_SALES']
      }
    ]
  },
  // {
  //   header: 'sections.customization',
  //   sections: [
  //     {
  //       label: 'sections.domainTablesConfiguration',
  //       route: '/domainTablesConfiguration'
  //     }
  //   ],
  //   requiredScope: 'MANAGE_DOMAIN_SETTINGS'
  // },
  {
    header: 'sections.administration',
    sections: [
      {
        label: 'sections.userManagement',
        route: '/users'
      },
      {
        label: 'sections.cleanIt',
        route: '/clean-it',
        requiredScope: 'CLEAN_IT'
      },
      {
        label: 'sections.offerViewer',
        route: '/offers-viewer',
        requiredScope: 'OFFERS_VIEWER'
      }
    ],
    requiredScope: 'MANAGE_SETTINGS'
  }
]
